"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var InboxRulesFolderDropdown_1 = require("./InboxRulesFolderDropdown");
var IncludesWordsInput_1 = require("./IncludesWordsInput");
var getClauseTypeProperties_1 = require("../actions/helpers/getClauseTypeProperties");
var getExistingClauseTypesInSection_1 = require("../actions/helpers/getExistingClauseTypesInSection");
var getHeaderTextFromHeaderType_1 = require("../actions/helpers/getHeaderTextFromHeaderType");
var getImportanceOptions_1 = require("../actions/helpers/getImportanceOptions");
var getInboxRuleMessageFlagOptions_1 = require("../actions/helpers/getInboxRuleMessageFlagOptions");
var getInboxRuleMessageTypeOptions_1 = require("../actions/helpers/getInboxRuleMessageTypeOptions");
var getSensitivityOptions_1 = require("../actions/helpers/getSensitivityOptions");
var setClauseErrorText_1 = require("../actions/helpers/setClauseErrorText");
var setFocusedClauseId_1 = require("../actions/helpers/setFocusedClauseId");
var setIncludesWordsInputText_1 = require("../actions/helpers/setIncludesWordsInputText");
var removeClause_1 = require("../actions/removeClause");
var setClauseType_1 = require("../actions/setClauseType");
var setClauseValue_1 = require("../actions/setClauseValue");
var store_1 = require("../store/store");
var isValidClause_1 = require("../utils/isValidClause");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var TextField_1 = require("office-ui-fabric-react/lib/TextField");
var owa_datepicker_1 = require("owa-datepicker");
var owa_datetime_1 = require("owa-datetime");
var ReadWriteRecipientWellWithFindControl_1 = require("owa-readwrite-recipient-well/lib/components/ReadWriteRecipientWellWithFindControl");
var RecipientType_1 = require("owa-recipient-common/lib/store/schema/RecipientType");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var React = require("react");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var styles = require('./InboxRuleClause.scss');
var classNames = require('classnames/bind').bind(styles);
var InboxRuleClause = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRuleClause, _super);
    function InboxRuleClause() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getClauseValueInput = function () {
            var clauseId = _this.props.clauseId;
            var selectedClause = store_1.default.inboxRulesEditState.clauseMap.get(_this.props.clauseId);
            switch (selectedClause.clauseType) {
                case 'from':
                case 'to':
                case 'forwardTo':
                case 'forwardAsAttachmentTo':
                case 'redirectTo':
                    return _this.renderRecipientWell(selectedClause);
                case 'subjectIncludes':
                case 'subjectOrBodyIncludes':
                case 'inTheBody':
                case 'inTheSenderAddress':
                case 'inTheRecipientAddress':
                case 'inTheMessageHeader':
                    setIncludesWordsInputText_1.default(clauseId, '');
                    return _this.renderIncludesWordsInput(clauseId);
                case 'withImportance':
                case 'markImportance':
                    return _this.renderClauseValueDropdown(getImportanceOptions_1.default());
                case 'sensitivity':
                    return _this.renderClauseValueDropdown(getSensitivityOptions_1.default());
                case 'flag':
                    return _this.renderClauseValueDropdown(getInboxRuleMessageFlagOptions_1.default());
                case 'type':
                    return _this.renderClauseValueDropdown(getInboxRuleMessageTypeOptions_1.default());
                case 'atLeast':
                case 'atMost':
                    return _this.renderNumberTextField(selectedClause);
                case 'moveTo':
                case 'copyTo':
                    return _this.renderFolderDropdown(clauseId);
                case 'onTheToOrCcLine':
                case 'theOnlyRecipientListed':
                case 'onTheToLine':
                case 'onTheCcLine':
                case 'notOnTheToLine':
                case 'attachment':
                case 'delete':
                case 'pin':
                case 'read':
                case 'junk':
                case null:// no clause selected from the clause type dropdown ('select a clause')
                    return null; // No second input
                case 'before':
                case 'after':
                    return _this.renderDatePicker(selectedClause);
                // Other cases return null, default throw error
                default:
                    throw new Error('Cannot get clause value input for a clause type that does not exist');
            }
        };
        _this.onTextFieldChanged = function (value) {
            var num = Number(value);
            if (!isNaN(num)) {
                setClauseValue_1.default(num, _this.props.clauseId);
            }
        };
        _this.onDateSelected = function (date) {
            setClauseValue_1.default(date, _this.props.clauseId);
        };
        _this.removeFocusAndValidate = function () {
            var clauseId = _this.props.clauseId;
            setClauseErrorText_1.default(clauseId, isValidClause_1.default(clauseId));
            setFocusedClauseId_1.default(clauseId, false /* shouldSetAsFocused */);
        };
        return _this;
    }
    InboxRuleClause.prototype.render = function () {
        var _this = this;
        var clauseId = this.props.clauseId;
        var sectionType = this.props.sectionType;
        var selectedClause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
        return (React.createElement("div", { className: styles.clauseContainer, key: clauseId },
            React.createElement(Dropdown_1.Dropdown, { onFocus: function () { return setFocusedClauseId_1.default(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return setFocusedClauseId_1.default(clauseId, false /* shouldSetAsFocused */); }, id: 'dropdown' + clauseId, placeHolder: owa_options_strings_1.default.options_inboxRules_clauseTypeDropdownPlaceholder, options: this.getClauseDropdownOptions(), selectedKey: this.getDropdownKey(selectedClause.clauseType), className: styles.clauseTypesDropdown, onChanged: function (option) { return _this.onClauseTypeChanged(option); } }),
            this.getClauseValueInput(),
            this.shouldShowRemoveClauseButton() && (React.createElement(Button_1.IconButton, { className: styles.removeClauseButton, iconProps: {
                    iconName: "Cancel" /* Cancel */,
                    styles: {
                        root: styles.cancelIcon,
                    },
                }, onClick: function () { return removeClause_1.default(clauseId, sectionType); } }))));
    };
    InboxRuleClause.prototype.getClauseDropdownOptions = function () {
        var items = [];
        var clauseId = this.props.clauseId;
        var sectionType = this.props.sectionType;
        var clauseTypeOptions = this.props.clauseTypeOptions;
        var existingClauseTypes = getExistingClauseTypesInSection_1.default(this.props.sectionType);
        var selectedClause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
        var previousHeaderType = null;
        for (var i = 0; i < clauseTypeOptions.length; i++) {
            var clauseType = clauseTypeOptions[i];
            var isSelectedClauseType = selectedClause.clauseType == clauseType;
            var hasClauseType = existingClauseTypes.has(clauseType);
            // Do not add the clause type to the dropdown options if the clause type...
            // 1) is not the current clause's type AND
            // 2) has been used already
            if (!isSelectedClauseType && hasClauseType) {
                continue;
            }
            var clauseTypeProperties = getClauseTypeProperties_1.default(clauseType);
            var clauseHeaderType = clauseTypeProperties.headerType;
            // Only push a header if we are first element or if the next clause type's header is different than the previous's
            if (!previousHeaderType || clauseHeaderType != previousHeaderType) {
                items.push({
                    key: sectionType + clauseHeaderType,
                    text: getHeaderTextFromHeaderType_1.default(clauseHeaderType),
                    itemType: Dropdown_1.DropdownMenuItemType.Header,
                });
            }
            // If clause type is junk, need to make sure the segmentation settings have junk turned on before adding to dropdown
            if (clauseType !== 'junk' || getUserConfiguration_1.default().SegmentationSettings.JunkEMail) {
                items.push({
                    key: this.getDropdownKey(clauseType),
                    text: clauseTypeProperties.dropdownOptionText,
                    data: clauseTypeProperties,
                });
            }
            previousHeaderType = clauseHeaderType;
        }
        return items;
    };
    InboxRuleClause.prototype.getDropdownKey = function (clauseType) {
        return this.props.sectionType + clauseType;
    };
    InboxRuleClause.prototype.onClauseTypeChanged = function (clauseTypeDropdownOption) {
        var clauseId = this.props.clauseId;
        setClauseType_1.default(clauseTypeDropdownOption.data.clauseType, clauseId);
        setClauseValue_1.default(clauseTypeDropdownOption.data.initialValue, clauseId);
        // clear the error text if the previous clause had invalid input
        setClauseErrorText_1.default(clauseId, true /* isValidClause */);
    };
    InboxRuleClause.prototype.onClauseValueChanged = function (clauseValueDropdownOption) {
        var clauseId = this.props.clauseId;
        setClauseValue_1.default(clauseValueDropdownOption.data, clauseId);
        // clear the error text if the previous value was invalid
        setClauseErrorText_1.default(clauseId, true /* isValidClause */);
    };
    InboxRuleClause.prototype.renderIncludesWordsInput = function (clauseId) {
        var _this = this;
        var selectedClause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
        return (React.createElement(IncludesWordsInput_1.default, { clauseId: clauseId, placeHolderText: this.getIncludesWordsPlaceholderText(selectedClause.clauseType), onFocus: function () { return setFocusedClauseId_1.default(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); } }));
    };
    InboxRuleClause.prototype.renderClauseValueDropdown = function (dropdownOptionsData) {
        var _this = this;
        var dropdownOptions = [];
        var currentSelectedValue = store_1.default.inboxRulesEditState.clauseMap.get(this.props.clauseId)
            .clauseValue;
        var selectedKey = currentSelectedValue ? currentSelectedValue.toString() : null;
        var clauseId = this.props.clauseId;
        dropdownOptionsData.forEach(function (option) {
            dropdownOptions.push({
                key: option.value.toString(),
                text: option.text,
                data: option.value,
            });
        });
        return (React.createElement("div", { className: styles.clauseValueContainer },
            React.createElement(Dropdown_1.Dropdown, { onFocus: function () { return setFocusedClauseId_1.default(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); }, options: dropdownOptions, onChanged: function (option) { return _this.onClauseValueChanged(option); }, errorMessage: store_1.default.inboxRulesEditState.clauseErrorTextMap.get(clauseId), placeHolder: owa_options_strings_1.default.options_inboxRules_clauseValueDropdownPlaceholder, selectedKey: selectedKey })));
    };
    InboxRuleClause.prototype.renderFolderDropdown = function (clauseId) {
        var _this = this;
        return (React.createElement(InboxRulesFolderDropdown_1.default, { clauseId: clauseId, dropdownFolderList: store_1.default.dropdownFolders, onFocus: function () { return setFocusedClauseId_1.default(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); } }));
    };
    InboxRuleClause.prototype.renderRecipientWell = function (selectedClause) {
        var _this = this;
        var clauseId = this.props.clauseId;
        var errorText = store_1.default.inboxRulesEditState.clauseErrorTextMap.get(this.props.clauseId);
        var value = store_1.default.inboxRulesEditState.clauseMap.get(this.props.clauseId)
            .clauseValue;
        var numPeople;
        if (value && value.recipients.length) {
            numPeople = value.recipients.length;
        }
        else {
            numPeople = 0;
        }
        return (React.createElement("div", { className: styles.recipientWellContainer },
            React.createElement("div", { className: classNames(styles.recipientWell, errorText && numPeople == 0 && styles.hasError), tabIndex: -1, onFocus: function () { return setFocusedClauseId_1.default(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); } },
                React.createElement(ReadWriteRecipientWellWithFindControl_1.default, { recipientWell: selectedClause.clauseValue, recipientType: RecipientType_1.RecipientType.None, size: 0 /* Small */ })),
            numPeople == 0 && React.createElement("span", { className: styles.recipientWellError },
                " ",
                errorText,
                " ")));
    };
    InboxRuleClause.prototype.renderNumberTextField = function (selectedClause) {
        var _this = this;
        var clauseId = this.props.clauseId;
        return (React.createElement(TextField_1.TextField, { className: styles.clauseDateSizeValueContainer, onFocus: function () { return setFocusedClauseId_1.default(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); }, value: selectedClause.clauseValue.toString(), onChanged: this.onTextFieldChanged, errorMessage: store_1.default.inboxRulesEditState.clauseErrorTextMap.get(clauseId), suffix: owa_options_strings_1.default.options_inboxRules_kb }));
    };
    InboxRuleClause.prototype.renderDatePicker = function (selectedClause) {
        var _this = this;
        var selectedClauseValue = selectedClause.clauseValue;
        var todayDate = new Date(owa_datetime_1.now());
        var defaultDate = selectedClauseValue ? new Date(selectedClauseValue) : todayDate;
        return (React.createElement(owa_datepicker_1.default, { ref: function (ref) { return (_this.owaDatePickerControl = ref); }, className: styles.clauseDateSizeValueContainer, isMonthPickerVisible: false, value: defaultDate, onSelectDate: this.onDateSelected, minDate: todayDate }));
    };
    InboxRuleClause.prototype.getIncludesWordsPlaceholderText = function (clauseType) {
        return clauseType == 'inTheSenderAddress' || clauseType == 'inTheRecipientAddress'
            ? owa_options_strings_1.default.options_inboxRules_addressIncludesOptionPlaceholder
            : owa_options_strings_1.default.options_inboxRules_containsOptionPlaceholder;
    };
    // show remove clause button if there is more than one clause in conditional/action sections or for
    // any clause in the exception section
    InboxRuleClause.prototype.shouldShowRemoveClauseButton = function () {
        // always show for exceptions since it's an optional field
        return (this.props.sectionType == 'exception' ||
            // otherwise, show if there is more than one clause in conditional/action sections
            this.props.sectionClauseIds.length > 1);
    };
    InboxRuleClause = tslib_1.__decorate([
        mobx_react_1.observer
    ], InboxRuleClause);
    return InboxRuleClause;
}(React.Component));
exports.default = InboxRuleClause;
//# sourceMappingURL=InboxRuleClause.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/components/InboxRuleClause.js
// module id = 5185
// module chunks = 2